import axios from 'axios'
import store from '../store';

export default {
    get: (filters) => axios.post('vehicles',filters),
    show: (data) => axios.post('vehicles/show', data),
    nextCode: (data) => axios.post('vehicles/next-code', data),
    deleteImage: (data) => axios.post('vehicles/delete-image', data),
    getByCategory: (category) => axios.post('vehicles',{category: category}),
    store: (data) => axios.post('vehicles/store', data),
    import: (data) => axios.post('vehicles/import', data),
    storeQR: (data) => axios.post('vehicles/qr-store', data),
    update: (data) => axios.post('vehicles/update', data),
    updateQR: (data) => axios.post('vehicles/qr-update', data),
    active: (id) => axios.post('vehicles/active', id),
    deactive: (id) => axios.post('vehicles/deactive', id),
    delete: (id) => axios.post('vehicles/delete', id),
    downloadExcel: (filters) => axios.post('vehicles/download-excel',filters).then(function(response){
        if(response.type == "success"){
            window.open(response.data, '_blank');
        }
        else{
            store.commit('toast', {color: response.type, message: response.message});
        }
    }),
    downloadRecord: (data) => axios.post('vehicles/download-record',data).then(function(response){
        if(response.type == "success"){
            window.open(response.data, '_blank');
        }
        else{
            store.commit('toast', {color: response.type, message: response.message});
        }
    }),
    downloadSheet: (data) => axios.post('vehicles/download-sheet',data).then(function(response){
        if(response.type == "success"){
            window.open(response.data, '_blank');
        }
        else{
            store.commit('toast', {color: response.type, message: response.message});
        }
    }),
    downloadProfileSheet: (data) => axios.post('vehicles/download-profile-sheet',data).then(function(response){
        if(response.type == "success"){
            window.open(response.data, '_blank');
        }
        else{
            store.commit('toast', {color: response.type, message: response.message});
        }
    }),
    initTags: (quantity) => axios.post('vehicles/init-tags',{quantity: quantity}).then(function(response){
        if(response.type == "success"){
            window.open(response.data, '_blank');
        }
        else{
            store.commit('toast', {color: response.type, message: response.message});
        }
    }),
    downloadTags: (filters) => axios.post('vehicles/download-tags',filters).then(function(response){
        if(response.type == "success"){
            window.open(response.data, '_blank');
        }
        else{
            store.commit('toast', {color: response.type, message: response.message});
        }
    }),
    downloadTagsMini: (filters) => axios.post('vehicles/download-tags-mini',filters).then(function(response){
        if(response.type == "success"){
            window.open(response.data, '_blank');
        }
        else{
            store.commit('toast', {color: response.type, message: response.message});
        }
    }),
    getQrAsset: (code) => axios.post('qr-vehicles', {code: code}),
    getPublicQrAsset: (code) => axios.post('qr-public-vehicles', {code: code}),   
}